import { Card, Illustration, Text } from "@clipboard-health/ui-components";
import { CardContent, Stack } from "@mui/material";

export function InterviewIncentiveBanner() {
  return (
    <Card
      sx={(theme) => ({
        background: theme.palette.placement?.feature.gradient,
      })}
    >
      <CardContent>
        <Stack spacing={3} flexDirection="row" alignItems="center">
          <Stack spacing={6}>
            <Text semibold variant="h6">
              $50 First Interview Bonus
            </Text>
            <Text>Attend your first job interview at a Childcare Center and earn a bonus!</Text>
          </Stack>
          <Illustration type="instant-pay" />
        </Stack>
      </CardContent>
    </Card>
  );
}
